<template>
  <div v-if="mainLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
  <div v-if="mainError" class="mc-error">{{ mainError }}</div>
  <div v-if="mainLoaded" class="cr-main-page__info">
    <div class="cr-main-page__info-item">
      <div class="cr-main-page__info-title">
        {{ main.header1 }}
      </div>
      <div class="cr-main-page__info-text" v-html="main.text1">

      </div>
      <ul class="cr-main-page__info-contacts">
        <li v-if="main.address" class="cr-main-page__info-contacts-item">
          {{ main.address }}
        </li>
        <li v-if="main.phone" class="cr-main-page__info-contacts-item">
          <a :href="'tel:'+main.phone">
            {{ main.phone }}
          </a>
        </li>
        <li v-if="main.email" class="cr-main-page__info-contacts-item">
          <a :href="'mailto:'+main.email">
            {{ main.email }}
          </a>
        </li>
      </ul>
      <ul class="cr-social">
        <li v-if="main.site" class="cr-social__item">
          <a class="cr-social__link" :href="main.site">
            <img class="cr-social__image" src="assets/img/svg/logo-link.svg" width="45" height="45" alt="">
          </a>
        </li>
        <li v-if="main.vk" class="cr-social__item">
          <a class="cr-social__link" :href="main.vk">
            <img class="cr-social__image" src="assets/img/svg/logo-vk.svg" width="45" height="45" alt="">
          </a>
        </li>
        <li v-if="main.ok" class="cr-social__item">
          <a class="cr-social__link" :href="main.ok">
            <img class="cr-social__image" src="assets/img/svg/logo-ok.svg" width="45" height="45" alt="">
          </a>
        </li>
        <li  v-if="main.tg"class="cr-social__item">
          <a class="cr-social__link" :href="main.tg">
            <img class="cr-social__image" src="assets/img/svg/logo-tg.svg" width="45" height="45" alt="">
          </a>
        </li>
      </ul>
    </div>
    <div class="cr-main-page__info-item">
      <div class="cr-main-page__info-text" v-html="main.text2"></div>
    </div>
    <div class="cr-main-page__info-item">
      <Menu></Menu>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Menu from './Menu.vue'
export default {
  data: () => ({

  }),
  created() {
    this.fetchMain();
  },
  computed: {
    ...mapGetters('main', [
      'main',
      'mainLoading',
      'mainError',
      'mainLoaded'
    ]),
  },
  components: {Menu},
  methods: {
    ...mapActions('main', [
      'fetchMain'
    ]),
  },
}
</script>